import React from 'react';
import {
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  Paper,
  Alert,
} from '@mui/material';

const WelcomePreparation = ({ 
  selectedEmployee, 
  onStepComplete, 
  onStepIncomplete, 
  isCompleted,
  employeeProgress 
}) => {
  if (!selectedEmployee) {
    return (
      <Alert severity="info">
        Please select an employee first to manage their welcome preparation.
      </Alert>
    );
  }

  const handleCheckboxChange = (event) => {
    if (event.target.checked) {
      onStepComplete();
    } else {
      onStepIncomplete();
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Welcome Preparation Management
      </Typography>
      
      <Paper sx={{ p: 3, mb: 2 }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          This step involves preparing welcome kit and orientation materials for the selected employee.
        </Typography>
        
        <FormControlLabel
          control={
            <Checkbox
              checked={isCompleted}
              onChange={handleCheckboxChange}
              color="primary"
            />
          }
          label="Mark as Complete"
        />
      </Paper>
    </Box>
  );
};

export default WelcomePreparation; 